@switch(status) {
  @case ("error") {
    <i class="fa-solid fa-triangle-exclamation error"></i>
  }
  @case ("loading") {
    <tp-spinner [size]="20"/>
  }
  @case ("loading_paused") {
    <i class="fa-solid fa-circle inactive"></i>
  }
  @case ("inactive") {
    <i class="fa-regular fa-circle inactive"></i>
  }
  @case ("ok") {
    <i class="fa-solid fa-circle ok"></i>
  }
}
